 import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Constants from "../constant";
import axios from "axios";
import ErrorBoundary from "./ErrorBoundary";

const PrivateRoute = ({ children }) => {
	const [auth, setAuth] = useState(false);
	let navigate = useNavigate();
	useEffect(() => {
		axios
			.get(`${Constants?.LOCAL_URL}/api/auth/verify`, {
				withCredentials: true,
			})

			.then(() => {
				setAuth(true);
			})
			.catch(() => {
				setAuth(false);
				navigate("/");
			});
	}, []);
	return (
		<>
			{auth && <ErrorBoundary>{children}</ErrorBoundary>}
		</>
	);
};
export default PrivateRoute;
